import { isLocalUrl } from '../helpers/helpers';

export default function seoWidget() {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;
  const $widget = $(`#${widgetName}`);
  const wrapContainerClass = 'seoWidget-container';

  $widget.wrap(`<div class="${wrapContainerClass}"><div class="inner-container"></div></div>`);

  return saffire.widgets.cardWidget($($widget), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    scriptPath: widgetOpts.scriptPath,
    maxItemsVisible: 1,
    itemsPerPanel: 1,
    link: [''],
    cardWidgetLoaded: function (data, _owl, hasData) {
      if (hasData) {
        createCustomSeo(data.items[0]);
      } else {
        $(`.${wrapContainerClass}`).remove();
      }
    },
  });

  function createCustomSeo(widgetData) {
    const { Title, Description, URL } = widgetData;
    const $seo = $widget.find('.card-widget-item');
    const localUrl = isLocalUrl(URL) ? '' : 'target="_blank"';

    $seo.replaceWith(`
      <h1 class="seo-title">${Title}</h1>
      <div class="seo-description">${Description}</div>
      ${URL == null ? '' : `<a href="${URL}" class="button" ${localUrl}>Learn More</a>`}

    `);
  }
}
